import OlMap from 'ol/Map';

import { Popup, PopupProps } from 'lib/classes/popup';
import { assetURL } from 'lib/utilities/asset';
import { getLocaleString } from 'lib/localization/vendor';

import SearchResult from 'views/SearchResult';

const SearchResultPopup = new Popup({
	title: () => getLocaleString('searchresult'),
	style: {width: '100%', minWidth: 350},
	render: function() {
		const olMap:OlMap = this.get('map');
		const result:any = this.get('search-result');
		
		return (
			<SearchResult 
				olMap={olMap} 
				result={result} 
				title={this.get('title')}
				expandedView={true} 
			/>
		)
	}
});

export default SearchResultPopup;